(function () { 
  'use strict';

  /* =========================================================================
     BUY-NOW ABANDON CLEANUP (runs on every page load, before the drawer init)
     -------------------------------------------------------------------------
     A true "Buy It Now" must not leave the single item in the cart if the
     shopper abandons GoKwik. GoKwik's popup is a cross-origin iframe, so we
     cannot detect its close from the parent page reliably. Instead we use a
     durable flag:
       • On Buy It Now: store the original-cart snapshot + a flag in
         sessionStorage, THEN open GoKwik.
       • If the shopper completes the order, GoKwik lands them on an order /
         thank-you page — we detect that and CLEAR the flag (keep purchase).
       • If the shopper abandons and returns to any store page (the collection
         page reappearing after the popup closes counts), the flag is still
         set → we restore the original cart (removing the Buy-Now item) and
         clear the flag.
     ========================================================================= */
  var ZWC_BUYNOW_KEY = 'zwcBuyNowPending';
  // URL fragments that indicate a COMPLETED order — cleanup must NOT run then.
  // TODO: confirm your real GoKwik thank-you URL and adjust if needed.
  var ORDER_URL_HINTS = ['/thank', 'thank_you', '/orders/', 'order-confirm', 'checkout/thank'];

  function pathLooksLikeOrder() {
    var href = (window.location.href || '').toLowerCase();
    return ORDER_URL_HINTS.some(function (h) { return href.indexOf(h) !== -1; });
  }

  function runBuyNowCleanup() {
    var raw;
    try { raw = sessionStorage.getItem(ZWC_BUYNOW_KEY); } catch (e) { raw = null; }
    if (!raw) return;

    // If we're on an order/thank-you page, the purchase succeeded → keep cart,
    // just clear the flag.
    if (pathLooksLikeOrder()) {
      try { sessionStorage.removeItem(ZWC_BUYNOW_KEY); } catch (e) {}
      return;
    }

    var data;
    try { data = JSON.parse(raw); } catch (e) { data = null; }
    // Clear the flag first so cleanup runs only once.
    try { sessionStorage.removeItem(ZWC_BUYNOW_KEY); } catch (e) {}
    if (!data) return;

    var snapshot = data.snapshot || [];
    // Restore the original cart (clear, then re-add the originals).
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        if (!snapshot.length) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: snapshot })
        });
      })
      .then(function () {
        // Nudge theme drawers to refresh so the removed item disappears visually.
        ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
          try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) {}
        });
      })
      .catch(function () { /* best effort */ });
  }

  // Run cleanup as early as possible on every load.
  runBuyNowCleanup();

  function initQuickView() {
    var qv = document.querySelector('[data-zwc-quickview]');
    if (!qv || qv.dataset.zwcQvInit) return;
    qv.dataset.zwcQvInit = '1';

    var qvOverlay = document.querySelector('[data-zwc-qv-overlay]');
    var qvBody = qv.querySelector('[data-zwc-qv-body]');
    var qvCloseBtn = qv.querySelector('[data-zwc-qv-close]');
    var paymentImg = qv.getAttribute('data-zwc-payment-img') || '';
    var showViewers = true;

    /* ---- size-chart modal refs (now a sibling of the drawer, on <body>) ---- */
    var scModal = document.querySelector('[data-zwc-qv-sizechart-modal]');
    var scContent = document.querySelector('[data-zwc-qv-sizechart-content]');
    var scClose = document.querySelector('[data-zwc-qv-sizechart-close]');
    var scBackdrop = document.querySelector('[data-zwc-qv-sizechart-backdrop]');

    /* ---- scroll-lock state ---- */
    var scrollY = 0;
    function insideDrawer(target) {
      if (!target || !target.closest) return false;
      return target.closest('[data-zwc-quickview]') ||
             target.closest('[data-zwc-qv-sizechart-modal]');
    }
    function blockTouch(e) {
      if (!insideDrawer(e.target)) e.preventDefault();
    }
    function blockWheel(e) {
      if (!insideDrawer(e.target)) e.preventDefault();
    }
    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('zwc-qv-lock');
      document.body.classList.add('zwc-qv-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', blockTouch, { passive: false });
      document.addEventListener('wheel', blockWheel, { passive: false });
    }
    function unlockScroll() {
      document.removeEventListener('touchmove', blockTouch, { passive: false });
      document.removeEventListener('wheel', blockWheel, { passive: false });
      document.documentElement.classList.remove('zwc-qv-lock');
      document.body.classList.remove('zwc-qv-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ---------- OPEN / CLOSE ---------- */
    function openQV() {
      if (qvOverlay) qvOverlay.hidden = false;
      requestAnimationFrame(function () { qv.classList.add('is-open'); });
      qv.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function closeQV() {
      closeSizeChart();
      qv.classList.remove('is-open');
      qv.setAttribute('aria-hidden', 'true');
      unlockScroll();
      setTimeout(function () { if (qvOverlay) qvOverlay.hidden = true; }, 320);
    }
    if (qvCloseBtn) qvCloseBtn.addEventListener('click', closeQV);
    if (qvOverlay) qvOverlay.addEventListener('click', closeQV);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (scModal && scModal.classList.contains('is-open')) { closeSizeChart(); return; }
      if (qv.classList.contains('is-open')) closeQV();
    });

    /* ---------- SIZE-CHART MODAL ---------- */
    function sizeChartTemplateFor(handle) {
      var key = (handle === 'holiday-cozies') ? 'holiday-cozies' : 'default';
      var tpl = document.querySelector('[data-zwc-qv-sc-src="' + key + '"]');
      if (!tpl && key !== 'default') {
        tpl = document.querySelector('[data-zwc-qv-sc-src="default"]');
      }
      return tpl;
    }

    function openSizeChart(handle) {
      if (!scModal || !scContent) return;
      var tpl = sizeChartTemplateFor(handle);
      if (!tpl) return;
      scContent.innerHTML = '';
      scContent.appendChild(tpl.content.cloneNode(true));
      bindUnitToggle(scContent);
      scModal.classList.add('is-open');
      scModal.setAttribute('aria-hidden', 'false');
    }

    function closeSizeChart() {
      if (!scModal) return;
      scModal.classList.remove('is-open');
      scModal.setAttribute('aria-hidden', 'true');
    }

    if (scClose) scClose.addEventListener('click', closeSizeChart);
    if (scBackdrop) scBackdrop.addEventListener('click', closeSizeChart);

    function bindUnitToggle(scope) {
      var toggles = scope.querySelectorAll('[data-unit], .unit-toggle button, [data-size-unit]');
      if (!toggles.length) {
        var candidates = scope.querySelectorAll('button, span, a');
        toggles = Array.prototype.filter.call(candidates, function (el) {
          var t = (el.textContent || '').trim().toUpperCase();
          return t === 'IN' || t === 'CM';
        });
      }
      if (!toggles.length) return;

      function unitOf(el) {
        var u = el.getAttribute('data-unit') || el.getAttribute('data-size-unit');
        if (u) return u.trim().toLowerCase();
        return (el.textContent || '').trim().toLowerCase();
      }

      function applyUnit(unit) {
        Array.prototype.forEach.call(toggles, function (el) {
          el.classList.toggle('is-active', unitOf(el) === unit);
          el.setAttribute('aria-pressed', unitOf(el) === unit ? 'true' : 'false');
        });
        scope.querySelectorAll('[data-unit-value]').forEach(function (cell) {
          var cu = (cell.getAttribute('data-unit-value') || '').trim().toLowerCase();
          cell.style.display = (cu && cu !== unit) ? 'none' : '';
        });
        scope.querySelectorAll('[data-unit-table]').forEach(function (tbl) {
          var tu = (tbl.getAttribute('data-unit-table') || '').trim().toLowerCase();
          tbl.style.display = (tu && tu !== unit) ? 'none' : '';
        });
        scope.setAttribute('data-active-unit', unit);
      }

      Array.prototype.forEach.call(toggles, function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          applyUnit(unitOf(el));
        });
      });

      applyUnit(unitOf(toggles[0]));
    }

    /* ---------- DELEGATED TRIGGER (survives AJAX re-render) ---------- */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zwc-quickview-open]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;
      var card = trigger.closest('[data-zwc-card]');
      var preVariant = card ? card.getAttribute('data-selected-variant') : '';
      loadQuickView(handle, preVariant);
    });

    function loadQuickView(handle, preVariant) {
      qvBody.innerHTML = '<div class="zwc-qv-loading">Loading…</div>';
      openQV();
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { renderQuickView(p, preVariant); })
        .catch(function () {
          qvBody.innerHTML = '<div class="zwc-qv-loading">Could not load product.</div>';
        });
    }

    function renderQuickView(p, preVariant) {
      var state = { product: p, imageIndex: 0, variant: null, qty: 1, thumbStart: 0 };
      var THUMB_WINDOW = 4;

      var sizeOptIndex = -1;
      var colorOptIndex = -1;
      (p.options || []).forEach(function (name, i) {
        var n = (typeof name === 'string' ? name : name.name || '').toLowerCase();
        if (n.indexOf('size') !== -1) sizeOptIndex = i;
        if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) colorOptIndex = i;
      });

      var preVarObj = null;
      if (preVariant) {
        preVarObj = p.variants.find(function (v) { return String(v.id) === String(preVariant); });
      }

      var colorList = [];
      if (colorOptIndex >= 0) {
        var colorSeen = {};
        p.variants.forEach(function (v) {
          var cval = v.options[colorOptIndex];
          if (cval == null || colorSeen[cval]) return;
          colorSeen[cval] = true;
          colorList.push({
            value: cval,
            swatchImg: (v.featured_image && v.featured_image.src) ? v.featured_image.src : (p.featured_image || ''),
            imgId: (v.featured_image && v.featured_image.id != null) ? v.featured_image.id : null,
            firstVariant: v
          });
        });
      }

      var lockedColor = null;
      if (colorOptIndex >= 0) {
        if (preVarObj) {
          lockedColor = preVarObj.options[colorOptIndex];
        } else if (colorList.length) {
          lockedColor = colorList[0].value;
        }
      }

      var images = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);

      var idToIndex = {};
      if (p.media && p.media.length) {
        var imgSeq = 0;
        p.media.forEach(function (m) {
          if (m.media_type === 'image') {
            if (m.id != null) idToIndex[m.id] = imgSeq;
            imgSeq++;
          }
        });
      }

      function galleryIndexForColor(entry) {
        if (!entry) return -1;
        if (entry.imgId != null && idToIndex[entry.imgId] != null) {
          return idToIndex[entry.imgId];
        }
        if (entry.swatchImg) {
          var byUrl = images.findIndex(function (src) { return src === entry.swatchImg; });
          if (byUrl >= 0) return byUrl;
          var target = baseImgPath(entry.swatchImg);
          var byBase = images.findIndex(function (src) { return baseImgPath(src) === target; });
          if (byBase >= 0) return byBase;
        }
        return -1;
      }

      function baseImgPath(url) {
        if (!url) return '';
        var noQuery = url.split('?')[0];
        return noQuery.replace(/_(?:\d+x\d*|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.[a-z]+$)/i, '');
      }

      function sizesForColor(color) {
        var out = [];
        if (sizeOptIndex < 0) return out;
        var seen = {};
        p.variants.forEach(function (v) {
          if (color !== null && v.options[colorOptIndex] !== color) return;
          var val = v.options[sizeOptIndex];
          if (val && !seen[val]) { seen[val] = true; out.push(val); }
        });
        return out;
      }
      var sizeValues = sizesForColor(lockedColor);

      function variantForSize(sizeVal) {
        if (sizeOptIndex < 0) {
          if (lockedColor !== null && colorOptIndex >= 0) {
            var byColor = p.variants.find(function (v) { return v.options[colorOptIndex] === lockedColor; });
            if (byColor) return byColor;
          }
          if (preVarObj) return preVarObj;
          return p.variants[0];
        }
        return p.variants.find(function (v) {
          var sizeOk = v.options[sizeOptIndex] === sizeVal;
          var colorOk = (lockedColor === null) || (v.options[colorOptIndex] === lockedColor);
          return sizeOk && colorOk;
        });
      }
      function sizeAvailable(sizeVal) {
        var v = variantForSize(sizeVal);
        return v && v.available;
      }

      var hasCompare = p.compare_at_price && p.compare_at_price > p.price;

      var html = '';
      html += '<div class="zwc-qv-content">';

      html += '<div class="zwc-qv-left">';
      html += '<div class="zwc-qv-main-img" data-qv-main>';
      if (images.length > 1) {
        html += '<button type="button" class="zwc-qv-arrow zwc-qv-arrow-prev" data-qv-prev aria-label="Previous image"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M11 4L6 9l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        html += '<button type="button" class="zwc-qv-arrow zwc-qv-arrow-next" data-qv-next aria-label="Next image"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      }
      html += '<img data-qv-mainimg src="' + (images[0] || '') + '" alt="' + escapeHtml(p.title) + '">';
      html += '</div>';
      if (images.length > 1) {
        html += '<div class="zwc-qv-thumbs" data-qv-thumbs>';
        images.forEach(function (src, i) {
          html += '<button type="button" class="zwc-qv-thumb ' + (i === 0 ? 'is-active' : '') + '" data-qv-thumb="' + i + '"><img src="' + src + '" alt=""></button>';
        });
        html += '</div>';
      }
      html += '</div>';

      html += '<div class="zwc-qv-right">';
      html += '<h2 class="zwc-qv-name">' + escapeHtml(p.title) + '</h2>';

      html += '<div class="zwc-qv-price-row"><span class="zwc-qv-price" data-qv-price>' + money(p.price) + '</span>';
      if (hasCompare) html += '<span class="zwc-qv-compare">' + money(p.compare_at_price) + '</span>';
      html += '</div>';
      html += '<p class="zwc-qv-tax">Tax included. Shipping calculated at checkout.</p>';

      if (colorList.length > 1) {
        html += '<div class="zwc-qv-color-sec" data-qv-color-sec>';
        html += '<div class="zwc-qv-color-head"><span>COLOR</span>';
        html += '<span class="zwc-qv-color-name" data-qv-color-name>' + escapeHtml(lockedColor || '') + '</span></div>';
        html += '<div class="zwc-qv-colors" data-qv-colors>';
        colorList.forEach(function (c) {
          var isActive = (c.value === lockedColor);
          html += '<button type="button" class="zwc-qv-color-swatch ' + (isActive ? 'is-selected' : '') + '"' +
                  ' data-qv-color="' + escapeHtml(c.value) + '"' +
                  ' title="' + escapeHtml(c.value) + '" aria-label="' + escapeHtml(c.value) + '">' +
                  '<img src="' + (c.swatchImg || '') + '" alt="' + escapeHtml(c.value) + '"></button>';
        });
        html += '</div></div>';
      }

      html += '<div class="zwc-qv-size-wrap" data-qv-size-wrap>';
      html += renderSizeSectionHtml(sizeValues, sizeAvailable);
      html += '</div>';

      html += '<div class="zwc-qv-qty-sec"><p class="zwc-qv-qty-label">Quantity</p>';
      html += '<div class="zwc-qv-qty"><button type="button" class="zwc-qv-qty-btn" data-qv-minus aria-label="Decrease">−</button>';
      html += '<span class="zwc-qv-qty-count" data-qv-count>1</span>';
      html += '<button type="button" class="zwc-qv-qty-btn" data-qv-plus aria-label="Increase">+</button></div></div>';

      html += '<div class="zwc-qv-cta">';
      html += '<button type="button" class="zwc-qv-atc" data-qv-atc>ADD TO CART</button>';
      html += '<button type="button" class="zwc-qv-buy" data-qv-buy><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M2 9h20" stroke="currentColor" stroke-width="1.6"/></svg>BUY IT NOW</button>';
      html += '</div>';

      html += '<div class="zwc-qv-error" data-qv-error></div>';

      if (showViewers) {
        var n = 8 + Math.floor(Math.random() * 20);
        html += '<div class="zwc-qv-viewers"><span class="zwc-qv-viewers-dot"></span><span>' + n + ' people are viewing this right now</span></div>';
      }

      if (paymentImg) {
        html += '<div class="zwc-qv-payment"><img src="' + paymentImg + '" alt="Accepted payment methods" loading="lazy"></div>';
      }

      html += '<a class="zwc-qv-viewdetails" data-qv-viewdetails href="/products/' + encodeURIComponent(p.handle) + '">VIEW DETAILS<svg width="14" height="14" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';

      html += '</div>';
      html += '</div>';

      qvBody.innerHTML = html;

      var preEntry = null;
      if (lockedColor !== null) {
        preEntry = colorList.find(function (c) { return c.value === lockedColor; });
      }
      var preIdx = galleryIndexForColor(preEntry);
      if (preIdx >= 0) state.imageIndex = preIdx;

      var mainImg = qvBody.querySelector('[data-qv-mainimg]');
      var thumbs = qvBody.querySelectorAll('[data-qv-thumb]');

      function updateThumbWindow() {
        if (state.imageIndex < state.thumbStart) {
          state.thumbStart = state.imageIndex;
        } else if (state.imageIndex > state.thumbStart + THUMB_WINDOW - 1) {
          state.thumbStart = state.imageIndex - THUMB_WINDOW + 1;
        }
        var maxStart = Math.max(0, images.length - THUMB_WINDOW);
        if (state.thumbStart > maxStart) state.thumbStart = maxStart;
        if (state.thumbStart < 0) state.thumbStart = 0;

        var start = state.thumbStart;
        var end = start + THUMB_WINDOW;
        thumbs.forEach(function (t, i) {
          var visible = (i >= start && i < end);
          t.style.display = visible ? '' : 'none';
          t.classList.toggle('is-active', i === state.imageIndex);
        });
      }

      function setImage(i) {
        if (i < 0) i = images.length - 1;
        if (i >= images.length) i = 0;
        state.imageIndex = i;
        if (mainImg) mainImg.src = images[i];
        updateThumbWindow();
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setImage(parseInt(t.getAttribute('data-qv-thumb'), 10)); });
      });
      var prev = qvBody.querySelector('[data-qv-prev]');
      var next = qvBody.querySelector('[data-qv-next]');
      if (prev) prev.addEventListener('click', function () { setImage(state.imageIndex - 1); });
      if (next) next.addEventListener('click', function () { setImage(state.imageIndex + 1); });
      setImage(state.imageIndex);

      var errEl = qvBody.querySelector('[data-qv-error]');
      var priceEl = qvBody.querySelector('[data-qv-price]');
      var sizeWrap = qvBody.querySelector('[data-qv-size-wrap]');

      /* ---- VIEW DETAILS: append the selected variant to the URL so the
             product page opens pre-selected; unlock scroll before leaving ---- */
      var viewDetailsLink = qvBody.querySelector('[data-qv-viewdetails]');
      function syncViewDetailsHref() {
        if (!viewDetailsLink) return;
        var base = '/products/' + encodeURIComponent(p.handle);
        viewDetailsLink.href = state.variant ? base + '?variant=' + state.variant.id : base;
      }
      if (viewDetailsLink) {
        viewDetailsLink.addEventListener('click', function () {
          // Body is position:fixed while the drawer is open — restore it so
          // the browser doesn't snapshot a locked page into bfcache.
          unlockScroll();
        });
      }

      function wireSizeButtons() {
        var sizeBtns = qvBody.querySelectorAll('[data-qv-size]');
        sizeBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            if (b.hasAttribute('disabled')) return;
            sizeBtns.forEach(function (x) { x.classList.remove('is-selected'); });
            b.classList.add('is-selected');
            state.variant = variantForSize(b.getAttribute('data-qv-size'));
            if (priceEl && state.variant) priceEl.textContent = money(state.variant.price);
            syncViewDetailsHref();
          });
        });
        var scLinkInner = qvBody.querySelector('[data-qv-sizechart]');
        if (scLinkInner) {
          scLinkInner.addEventListener('click', function () { openSizeChart(p.handle); });
        }
        if (sizeOptIndex < 0) state.variant = variantForSize(null);
        syncViewDetailsHref();
      }
      wireSizeButtons();

      var colorBtns = qvBody.querySelectorAll('[data-qv-color]');
      var colorNameEl = qvBody.querySelector('[data-qv-color-name]');
      colorBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var newColor = btn.getAttribute('data-qv-color');
          if (newColor === lockedColor) return;
          lockedColor = newColor;

          colorBtns.forEach(function (x) { x.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (colorNameEl) colorNameEl.textContent = lockedColor;

          sizeValues = sizesForColor(lockedColor);
          if (sizeWrap) sizeWrap.innerHTML = renderSizeSectionHtml(sizeValues, sizeAvailable);
          state.variant = null;
          wireSizeButtons();

          var entry = colorList.find(function (c) { return c.value === lockedColor; });
          var idx = galleryIndexForColor(entry);
          if (idx >= 0) {
            setImage(idx);
          } else if (entry && entry.swatchImg && mainImg) {
            mainImg.src = entry.swatchImg;
          }

          if (sizeOptIndex < 0) {
            state.variant = variantForSize(null);
            if (priceEl && state.variant) priceEl.textContent = money(state.variant.price);
          }

          syncViewDetailsHref();

          if (errEl) errEl.textContent = '';
        });
      });

      var countEl = qvBody.querySelector('[data-qv-count]');
      var minus = qvBody.querySelector('[data-qv-minus]');
      var plus = qvBody.querySelector('[data-qv-plus]');
      if (minus) minus.addEventListener('click', function () { if (state.qty > 1) { state.qty--; countEl.textContent = state.qty; } });
      if (plus) plus.addEventListener('click', function () { state.qty++; countEl.textContent = state.qty; });

      function needSize() {
        if (!state.variant) {
          if (errEl) errEl.textContent = 'Please select a size.';
          return true;
        }
        if (errEl) errEl.textContent = '';
        return false;
      }

      var atcBtn = qvBody.querySelector('[data-qv-atc]');
      if (atcBtn) atcBtn.addEventListener('click', function () {
        if (needSize()) return;
        atcBtn.disabled = true; atcBtn.textContent = 'ADDING…';
        addToCart(state.variant.id, state.qty).then(function () {
          atcBtn.textContent = 'ADDED ✓';
          closeQV();
          openCartDrawerOrNotify();
          setTimeout(function () { atcBtn.textContent = 'ADD TO CART'; atcBtn.disabled = false; }, 700);
        }).catch(function () {
          if (errEl) errEl.textContent = 'Could not add to cart.';
          atcBtn.textContent = 'ADD TO CART'; atcBtn.disabled = false;
        });
      });

      // ---- buy it now (GoKwik via the on-page Featured-Product section) ----
      // 1. Snapshot original cart + persist a pending-abandon flag BEFORE
      //    opening GoKwik. If the shopper abandons, the flag survives the
      //    popup close (and even a page navigation) and cleanup runs on the
      //    next store page load. A completed order lands on a thank-you URL,
      //    where cleanup is skipped and the flag cleared.
      // 2. Replace cart with ONLY the selected variant (popup shows the right
      //    product, not the section's assigned product).
      // 3. Open the section's initialised #gokwik-buy-now.
      var buyBtn = qvBody.querySelector('[data-qv-buy]');
      if (buyBtn) buyBtn.addEventListener('click', function () {
        if (needSize()) return;
        buyBtn.disabled = true;
        var origText = buyBtn.textContent;
        buyBtn.textContent = 'PROCESSING…';
        var vId = state.variant.id, vQty = state.qty;

        snapshotCart().then(function (snapshot) {
          // Persist the abandon flag BEFORE we touch the cart / open GoKwik.
          try {
            sessionStorage.setItem(ZWC_BUYNOW_KEY, JSON.stringify({
              snapshot: snapshot,
              variantId: vId,
              ts: Date.now()
            }));
          } catch (e) {}

          return replaceCartWith(vId, vQty).then(function () {
            pokeCartChanged();
            waitForGokwikAndClick(function onReady(btn) {
              btn.click();
              setTimeout(function () { buyBtn.textContent = origText; buyBtn.disabled = false; }, 2500);
            }, function onGaveUp() {
              // GoKwik never opened. Clear the flag (we're not abandoning a
              // popup), restore cart, use native checkout.
              try { sessionStorage.removeItem(ZWC_BUYNOW_KEY); } catch (e) {}
              restoreCart(snapshot).then(function () { window.location.href = '/checkout'; });
            });
          });
        }).catch(function () {
          try { sessionStorage.removeItem(ZWC_BUYNOW_KEY); } catch (e) {}
          if (errEl) errEl.textContent = 'Could not proceed to checkout.';
          buyBtn.textContent = origText; buyBtn.disabled = false;
        });
      });
    }

    function renderSizeSectionHtml(sizeValues, sizeAvailableFn) {
      if (!sizeValues.length) return '';
      var html = '<div class="zwc-qv-size-sec"><div class="zwc-qv-size-head"><span>SELECT SIZE</span>';
      html += '<span class="zwc-qv-size-chart" data-qv-sizechart>Size Chart</span></div>';
      html += '<div class="zwc-qv-sizes" data-qv-sizes>';
      sizeValues.forEach(function (val) {
        var avail = sizeAvailableFn(val);
        html += '<button type="button" class="zwc-qv-size ' + (avail ? '' : 'is-soldout') + '" data-qv-size="' + escapeHtml(val) + '" ' + (avail ? '' : 'disabled') + '>' + escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
      return html;
    }

    function addToCart(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          sections: cartSectionsToRender(),
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    }

    function snapshotCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return (cart.items || []).map(function (it) {
            return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
          });
        })
        .catch(function () { return []; });
    }

    function replaceCartWith(variantId, qty) {
      return fetch('/cart/clear.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart || !cart.item_count) throw new Error('cart still empty');
            return cart;
          });
      });
    }

    function restoreCart(snapshot) {
      return fetch('/cart/clear.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }
      })
      .then(function () {
        if (!snapshot || !snapshot.length) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: snapshot })
        });
      })
      .then(function () { pokeCartChanged(); })
      .catch(function () { /* best effort */ });
    }

    function pokeCartChanged() {
      ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
        try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) {}
      });
    }

    function waitForGokwikAndClick(onReady, onGaveUp) {
      var attempts = 0;
      var maxAttempts = 20;
      var interval = 200;
      (function poll() {
        var btn = document.getElementById('gokwik-buy-now') ||
                  document.querySelector('.gokwik-checkout button');
        var enabled = btn && !btn.disabled && !btn.classList.contains('disabled');
        if (enabled) { onReady(btn); return; }
        attempts++;
        if (attempts >= maxAttempts) { if (onGaveUp) onGaveUp(); return; }
        setTimeout(poll, interval);
      })();
    }

    function cartSectionsToRender() {
      var ids = [];
      ['cart-drawer', 'cart-notification', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer']
        .forEach(function (id) {
          if (document.getElementById('shopify-section-' + id) || document.querySelector('[id*="' + id + '"]')) {
            ids.push(id);
          }
        });
      return ids;
    }

    function drawerLooksOpen(el) {
      if (!el) return false;
      return el.hasAttribute('open') ||
             el.classList.contains('is-open') ||
             el.classList.contains('active') ||
             el.getAttribute('aria-hidden') === 'false';
    }

    function openCartDrawerOrNotify() {
      // Prestige (and Maestrooo themes generally) attach their cart listeners
      // to document.documentElement — events dispatched on `document` never
      // pass through it, so they must be fired on documentElement directly.
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (cart) {
          // Prestige v7: SidebarCart listens for cart:refresh on
          // documentElement; openMiniCart:true makes the theme re-render
          // AND open the drawer itself in one shot.
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: true }
            }));
          } catch (e) {}
          // Prestige v8 / Impact-style: the cart-drawer web component
          // re-renders on cart:change.
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { cart: cart, baseEvent: 'variant:add' }
            }));
          } catch (e) {}
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cart }
            }));
          } catch (e) {}

          // Give the theme a beat to re-render, then force-open only if the
          // events alone didn't open it (avoids toggling it closed again).
          setTimeout(function () {
            var drawer = document.getElementById('cart-drawer') ||
                         document.querySelector('cart-drawer') ||
                         document.getElementById('sidebar-cart') ||
                         document.querySelector('#CartDrawer, .drawer--cart');
            if (drawerLooksOpen(drawer)) return;

            if (drawer && typeof drawer.show === 'function') {
              try { drawer.show(); return; } catch (e) {}
            }
            if (drawer && 'open' in drawer) {
              try {
                drawer.open = true;
                if (drawerLooksOpen(drawer)) return;
              } catch (e) {}
            }

            var opener = document.querySelector(
              '[aria-controls="cart-drawer"], ' +
              '[data-action="open-drawer"][data-drawer-id="sidebar-cart"], ' +
              '[data-cart-drawer-open], .js-cart-drawer-open, #cart-icon-bubble'
            );
            if (opener) { try { opener.click(); return; } catch (e) {} }

            if (drawer) drawer.setAttribute('open', '');
          }, 350);
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }
})();